import { Badge } from '@mantine/core';
import React from 'react';
import { BadgeShortList } from 'src/design/molecules/BadgeShortList';

export interface ITagBadgeListProps {
  tags: string[];
  maxItems?: number;
}

/** @registry Capped list of string tags rendered as light badges with +N overflow disclosure; use for scopes/roles/tag lists. */
export const TagBadgeList: React.FC<ITagBadgeListProps> = ({
  tags,
  maxItems,
}) => {
  const badges = tags.map((tag) => (
    <Badge key={tag} variant="light">
      {tag}
    </Badge>
  ));

  return <BadgeShortList items={badges} maxItems={maxItems} />;
};
